const moment = require('moment-timezone');

function makeDate(dateString, gmtOffset, timezone, offsetHours) {
  const gmtOffsetDateString = dateString + gmtOffset;
  //console.log(`${gmtOffsetDateString}`);
  const date = moment(gmtOffsetDateString).tz(timezone).add(offsetHours, "hour");
  return date;
}
function registrationStart(gmtOffset, timezone, dayInMarch, regStartOffset) {
  const dateString = `2017-03-${dayInMarch}T12:00:00`;
  //console.log(`registration start: `);
  return makeDate(dateString, gmtOffset, timezone, regStartOffset)
}

const REGISTRATION_END = `2017-04-04T11:00:00`;
function registrationEnd(gmtOffset, timezone) {
  //console.log(`registration end: `);
  return makeDate(REGISTRATION_END, gmtOffset, timezone, 0)
}

const EVENT_START = "2017-05-06T09:00:00";
function eventStart(gmtOffset, timezone, startTimeOffsetHours) {
  //console.log(`event start: `);
  return makeDate(EVENT_START, gmtOffset, timezone, startTimeOffsetHours);
}

module.exports = {makeDate, registrationStart, registrationEnd, eventStart};



// WEBPACK FOOTER //
// ./src/Dates.js